import { forwardRef } from 'react';
import { cn } from '@/lib/cn';

export type SpinnerProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const SIZE: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-3 w-3 border',
  md: 'h-4 w-4 border',
  lg: 'h-5 w-5 border-2',
};

/**
 * A 3/4 ring in `currentColor` — no hue of its own, so it inherits the button or
 * panel it sits in. 700ms linear.
 */
export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(function Spinner(
  { size = 'md', className, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      role="status"
      aria-hidden="true"
      className={cn(
        'inline-block shrink-0 rounded-full border-current border-r-transparent align-[-0.125em] animate-spin',
        SIZE[size],
        className,
      )}
      {...rest}
    />
  );
});
